import { render, staticRenderFns } from "./OwnersTable.vue?vue&type=template&id=5b5c908f&scoped=true"
import script from "./OwnersTable.vue?vue&type=script&lang=js"
export * from "./OwnersTable.vue?vue&type=script&lang=js"
import style0 from "./OwnersTable.vue?vue&type=style&index=0&id=5b5c908f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c908f",
  null
  
)

export default component.exports